/**
 * VisibilityToggleController
 *
 * Shows or hides target elements based on radio button or checkbox selection.
 *
 * Usage:
 *   <div data-controller="visibility-toggle"
 *        data-visibility-toggle-show-on-value-value="1"
 *        data-visibility-toggle-target-selector-value=".target-element">
 *     <input type="radio" name="field" value="1">
 *     <input type="radio" name="field" value="0">
 *   </div>
 *   <div class="target-element d-none">Hidden content</div>
 *
 * Options:
 *   - showOnValue: Value that triggers showing the target (default: 'true')
 *   - targetSelector: CSS selector for elements to show/hide
 */
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    showOnValue: { type: String, default: 'true' },
    targetSelector: String
  }

  connect() {
    this._boundChange = this._onChange.bind(this)
    this.element.addEventListener('change', this._boundChange)
    this._updateVisibility()
  }

  disconnect() {
    this.element.removeEventListener('change', this._boundChange)
  }

  _onChange() {
    this._updateVisibility()
  }

  _updateVisibility() {
    const checkedRadio = this.element.querySelector('input[type="radio"]:checked')
    const checkedCheckbox = this.element.querySelector('input[type="checkbox"]:checked')

    let shouldShow = false

    if (checkedRadio !== null) {
      shouldShow = checkedRadio.value === this.showOnValueValue
    } else if (checkedCheckbox !== null) {
      // For checkbox, show when checked and showOnValue is truthy
      shouldShow = checkedCheckbox.checked && (this.showOnValueValue === 'true' || this.showOnValueValue === '1')
    }

    if (this.targetSelectorValue) {
      document.querySelectorAll(this.targetSelectorValue).forEach(el => {
        el.classList.toggle('d-none', !shouldShow)
      })
    }
  }
}
